interface ColorPickerProps {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

export function ColorPicker({ value, onChange, disabled = false }: ColorPickerProps) {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
  };

  const handleTextChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    // Validate hex color format
    if (/^#[0-9A-Fa-f]{0,6}$/.test(newValue)) {
      onChange(newValue);
    }
  };

  return (
    <div className="color-picker">
      <div className="color-picker-swatch" style={{ backgroundColor: value }}>
        <input
          type="color"
          className="color-picker-input"
          value={value}
          onChange={handleChange}
          disabled={disabled}
        />
      </div>
      <input
        type="text"
        className="color-picker-value"
        value={value}
        onChange={handleTextChange}
        disabled={disabled}
        maxLength={7}
      />
    </div>
  );
}
